import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c88cd662&scoped=true&lang=pug"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=c88cd662&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88cd662",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c88cd662')) {
      api.createRecord('c88cd662', component.options)
    } else {
      api.reload('c88cd662', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c88cd662&scoped=true&lang=pug", function () {
      api.rerender('c88cd662', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vipMgm/giftContentAnniversaryTwentyTwentyThree/index.vue"
export default component.exports